import { useEffect, useState } from "react";
import { CheckCircle2, Circle, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";

const day = (d) => new Date(d).toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" });

const Row = ({ state, title, detail, id }) => {
  const Icon = { done: CheckCircle2, failed: XCircle, waiting: Loader2, todo: Circle }[state];
  const color = { done: "text-leaf", failed: "text-rose-600", waiting: "text-pinkb animate-spin", todo: "text-muted-foreground" }[state];
  return (
    <li className="flex items-start gap-3 py-3 border-t border-border first:border-0" data-testid={`launch-check-${id}`} data-state={state}>
      <Icon className={`h-5 w-5 shrink-0 mt-0.5 ${color}`} />
      <div><p className="text-sm font-medium text-navy">{title}</p><p className="text-xs text-muted-foreground mt-0.5">{detail}</p></div>
    </li>
  );
};

export const LaunchChecklist = () => {
  const [s, setS] = useState(null);
  useEffect(() => {
    const load = () => api.get("/admin/launch-status").then((r) => setS(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 15000);
    return () => clearInterval(t);
  }, []);
  if (!s) return null;
  const live = !!s.launched_at;
  const sending = live && !s.launch_email_status;
  const email = s.launch_email_status || "";
  const sc = s.stripe_catalog;
  const rows = [
    { id: "stripe", state: !sc ? "waiting" : sc.status !== "ready" ? "failed" : sc.mode === "live" ? "done" : "todo",
      title: "Payments set up in Stripe", detail: !sc ? "Checking Stripe…" : sc.status !== "ready" ? `Problem: ${sc.status}` : sc.mode === "live" ? "Live: memberships, Mini Plan prices and FOUNDINGMEMBER are ready to take real payments." : "Test mode here in the preview. The live site uses your live Stripe account." },
    { id: "launched", state: live ? "done" : "todo", title: "Club launched", detail: live ? `Switched on ${new Date(s.launched_at).toLocaleString("en-GB")}` : "Switch the testing phase off and save to launch." },
    { id: "waitlist-email", state: !live ? "todo" : sending ? "waiting" : email === "sent" ? "done" : email.startsWith("skipped") ? "todo" : "failed",
      title: "Launch email to the waitlist", detail: !live ? "Goes out from MailerLite the moment you launch." : sending ? "Sending…" : email === "sent" ? "Sent from MailerLite." : email.startsWith("skipped") ? "Skipped in the preview. It sends from the live site." : `Didn't send (${email}). Check the campaign in MailerLite.` },
    { id: "founding-code", state: !live ? "todo" : s.founding_deadline ? "done" : s.founding_deadline_error ? "failed" : "waiting",
      title: "FOUNDINGMEMBER 20% code", detail: !live ? "Gets a 7-day deadline at launch." : s.founding_deadline ? `Open until ${day(s.founding_deadline)}.` : s.founding_deadline_error ? `Stripe error: ${s.founding_deadline_error}` : "Setting the deadline…" },
    { id: "heads-up", state: !live ? "todo" : s.heads_up_sent == null ? "waiting" : s.heads_up_sent >= s.beta_testers ? "done" : "failed",
      title: "Heads-up email to beta testers", detail: !live ? "Each tester is told their free access carries on." : s.heads_up_sent == null ? "Sending…" : `${s.heads_up_sent} of ${s.beta_testers} delivered.` },
    { id: "tester-codes", state: !live ? "todo" : s.codes_failed ? "failed" : s.still_free ? "waiting" : "done",
      title: "Personal tester codes", detail: !live ? "Each tester gets a 30-day personal 20% code when you switch their free access off." : `${s.codes_issued} sent · ${s.still_free} testers still on free access${s.codes_failed ? ` · ${s.codes_failed} failed, switch their access off again to retry` : ""}.` },
  ];
  return (
    <div className="rounded-2xl border border-border bg-card p-6" data-testid="launch-checklist">
      <h3 className="text-xl font-semibold">Launch day checklist</h3>
      <ul className="mt-3">{rows.map((r) => <Row key={r.id} {...r} />)}</ul>
    </div>
  );
};
